import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { VerifyLinkTextWrapper, VerifyUserButton } from './subcomponents';
import { TextWrapper } from '../subcomponents';
import StatusMessage from '../StatusMessageBox';
import { ConfigContext } from '../../../context';
const VerifyMessageBox = () => {
    const { authenticationRedirect } = useContext(ConfigContext);
    const verifyUserLinkText = translate('verifyMessageBox.body');
    const verifyUserLink = (_jsx(VerifyUserButton, { buttonType: "text", "data-type": "please verify your account", "data-object": "link", "data-analytics": "clicktrackingevent", onClick: () => authenticationRedirect(), children: verifyUserLinkText }));
    return (_jsx(StatusMessage, { messageTitle: translate('verifyMessageBox.title'), messageDescription: _jsx(TextWrapper, { children: _jsx(VerifyLinkTextWrapper, { children: _jsx(Trans, { i18nKey: "verifyMessageBox", value: verifyUserLink, components: { verifyUserLink }, children: translate('verifyMessageBox.body', {
                        verifyUserLinkText
                    }) }) }) }) }));
};
export default VerifyMessageBox;
